export default __webpack_public_path__ + "static/media/chilltechDark.016570ab.png";